import { FormBuilder } from "components/FormBuilder/FormBuilder"
import React from 'react'
import { useTranslation } from "react-i18next";
import { OnlineMerchantManagement } from "../OnlineMerchantManagement";

const CARD_DEFAULT_VALUES = {
  cost: 0,
  mdr: 0,
  foreignMdr: 0,
  salesCommission: 0,
  referrerCommission: 0,
  remark: "",
}

/** @typedef {typeof ONLINE_MERCHANT_CARD_CONFIG} onlineProcessorCardConfig */
export const ONLINE_MERCHANT_CARD_CONFIG = {
  "VISA": {
    unavailableFields: [],
    defaultValues: {
      ...CARD_DEFAULT_VALUES,
    }
  },
  "MASTER": {
    unavailableFields: [],
    defaultValues: {
      ...CARD_DEFAULT_VALUES,
    }
  },
  "UNIONPAY": {
    unavailableFields: ["foreignMdr"],
    defaultValues: {
      ...CARD_DEFAULT_VALUES,
    }
  },
  "ALIPAY": {
    unavailableFields: ["foreignMdr"],
    defaultValues: {
      ...CARD_DEFAULT_VALUES,
    }
  },
  "WECHAT": {
    unavailableFields: ["foreignMdr"],
    defaultValues: {
      ...CARD_DEFAULT_VALUES,
    }
  }
}

/**
 * @param {Object} props 
 * @param {import("react-hook-form").UseFormReturn} props.formProps
 * @param {import("utils/useFormUndo/useFormUndo").useFormUndoReturn} props.formUndoProps
 * @param {[string[], React.Dispatch<React.SetStateAction<string[]>>]} props.editingCardTypeKeysState
 * @param {boolean} props.isCreate
 * @param {boolean} props.isEditing
 * @param {boolean} props.isLoading
 * @param {(string) => boolean} props.onMdrSave - callback to save edited row
 */
const OnlineMerchantManagementMdrSection = ({
  formProps,
  isCreate,
  isEditing,
  isLoading,
}) => {
  const { t: tLocal } = useTranslation("translation", { keyPrefix: "form.onlineMerchantManagement.merchant.mdrSection" });
  // const { t: tCommon } = useTranslation();

  const isDisabled = isLoading;
  const isReadOnly = !isCreate && !isEditing;

  return (
    <FormBuilder.Section
      title={tLocal("title")}
      titleVariant="h3"
    >
      <FormBuilder.Row itemsPerRow={1}>
        <OnlineMerchantManagement.Components.MdrTable
          formProps={formProps}
          isEditing={isEditing}
          isDisabled={isDisabled}
          isReadOnly={isReadOnly}
          config={Object.entries(ONLINE_MERCHANT_CARD_CONFIG).map(([cardType, config]) => ({
            cardTypeKey: cardType,
            unavailableFields: config.unavailableFields,
            defaultValues: config.defaultValues
          }))}
        />
      </FormBuilder.Row>
    </FormBuilder.Section>
  )
}

export default OnlineMerchantManagementMdrSection